require('es6-promise').polyfill(); // We need this so axios promise based xhr requests work on Internet Explorer
require("@babel/polyfill");
import 'slick-carousel'
import Stickyfill from 'stickyfilljs';
import './_bootstrap'
import submenuGradient from './_submenu-gradient'
import Vue from 'vue';
import lottie from 'lottie-web';
import GlobalMapOptions from './map-options'


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}


/**
 * Globally available libraries
 */
window.Vue = Vue;
window.lottie = lottie;
window.GlobalMapOptions = GlobalMapOptions;


/**
 * Position sticky polyfill
 */
var elements = document.querySelectorAll('.sticky');
Stickyfill.add(elements);


/**
 * Search widget
 */
import SearchWidget from './components/search-widget/search-widget-root'
const searchWidget = new Vue({
    el: '#searchWidget',
    components: {
        'alf-search-widget': SearchWidget
    }
});



/**
 * Newsletter widget
 */
import NewsletterWidget from './components/newsletter-widget/newsletter-widget-root';
const newsletterWidget = new Vue({
    el: '#newsletter__widget',
    components: {
        'alf-newsletter-widget': NewsletterWidget
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/site/app-main.js